
export default {
  props: {
    blok: {
      type: Object,
      default: () => ({
        classes: null,
        label: null,
        arrow: null,
        type: 'default',
        disabled: false,
        link_open: '_self',
        link: {
          url: null,
        },
      }),
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    buttonClick: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      hasText: false,
      isAnchorLink: false,
      isDisabled: false,
      isExternalLink: false,
    }
  },
  computed: {
    classObject() {
      return {
        'pointer-events-none bg-gray-300': this.isDisabled,
        ' rounded-full min-h-[36px] px-4 sm:px-[30px] inline-flex justify-center items-center pt-[2px] text-sm-semibold shadow-1':
          this.blok?.type === 'pill',
        ' inline-flex justify-start items-center pt-[2px] text-base-semibold min-h-[36px]':
          this.blok?.type === 'text',
        'w-full inline-flex justify-center items-center h-full':
          this.blok?.type === 'fullWidth',
        '': this.blok?.type === 'default',

        'md:hidden': this.blok.show === 'mobile',
        'hidden md:inline-flex': this.blok.show === 'tablet',
        'hidden lg:inline-flex': this.blok.show === 'desktop',
      }
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    setData() {
      this.hasText = this.$slots.default || this.blok?.label
      // check disable from blok and prop
      this.isDisabled = !!this.blok?.disabled
      // check if anchor link
      const isAnchorLink = this.blok?.link?.url?.charAt(0) === '#'
      this.isAnchorLink = !!isAnchorLink
      // check if external link and make sure its not an anchor link
      this.isExternalLink = this.blok?.link?.url && !!isAnchorLink !== true
    },
    handleScroll($event) {
      if (this.isAnchorLink) {
        // scroll to section
        const scrollTarget = $event.target.getAttribute('data-link')

        this.$gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: scrollTarget,
            offsetY: 70,
          },
        })
      }
    },
  },
}
